export const queryKeys = {
  banner: "banner",
  surah: "surah",
  programs: "programs",
  events: "events",
  campaigns: "campaigns",
  campaignsDonor: "campaignsDonor",
  user: "user",
  myRegistrations: "my-registrations",
  myFeedbacks: "my-feedbacks"
};
